import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { useCallback } from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { buildBrokerUrl } from './brokerUrl';
export const useHireBroker = domainName => {
  const isMobile = useIsMobile();
  return useCallback(() => {
    var _getPremiumEssentials;
    DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
      ctaClick: 'hire_broker',
      domain: domainName,
      deviceType: isMobile ? 'mobile' : 'desktop'
    });
    window.open(buildBrokerUrl({
      domainName,
      msid: (_getPremiumEssentials = getPremiumEssentialsSafe()) == null ? void 0 : _getPremiumEssentials.siteId
    }), '_top');
  }, [domainName, isMobile]);
};
//# sourceMappingURL=useHireBroker.js.map